import React from 'react';
import PropTypes from 'prop-types';
import ScrollableTabs from '../common/ScrollableTabs';
import MMETable from './MMETable';
import { REPORT_TYPE_OPTIONS_MAP } from './MMEConstants';

const MMEViewer = ({
  returnToEditor,
  statementVariableLabel,
  mmeAllTargets,
  reportType,
  runMMEReport,
  landingIndex,
}) => {
  const tabs = mmeAllTargets.map(tab => ({
    tab,
    content: (
      <div>
        <MMETable
          reportType={reportType}
        />
      </div>),
  }));
  return (
    <div className="mme-viewer-table-wrapper">
      <div className="column">
        <div className="mme-viewer-table-wrapper-header">
          <span>{REPORT_TYPE_OPTIONS_MAP[reportType]} </span>
          {reportType === 'SR' && <span>| {statementVariableLabel}</span>}
          <button type="button" className="back-to-mme-editor" onClick={() => returnToEditor()}>Report Editor</button>
        </div>
        <div className="mme-viewer-table-wrapper-tabs">
          {/* <DynamicTabs
            data-test="MMEDynamicTabs"
            styles={{ padding: '8px 31px' }}
            selectedIndex={0}
            tabs={tabs}
          /> */}
          <ScrollableTabs
            data-test="MMEScrollableTabs"
            tabs={tabs}
            reportType={reportType}
            runMMEReport={runMMEReport}
            landingIndex={landingIndex}
          />
        </div>
      </div>
    </div>
  );
};


MMEViewer.propTypes = {
  returnToEditor: PropTypes.func,
  statementVariableLabel: PropTypes.string,
  mmeAllTargets: PropTypes.instanceOf(Array),
  reportType: PropTypes.string,
  runMMEReport: PropTypes.func,
  landingIndex: PropTypes.number,
};

export default MMEViewer;
